<script lang="ts">
  /**
   * TOAST RENDERER — Displays all active toasts in the top-right corner.
   * Mount this ONCE in App.svelte. It reads from the global toastState.
   */
  import { toastState } from '../toast/toast.state.svelte';

  const iconMap: Record<string, string> = {
    success: '✅',
    error: '❌',
    warning: '⚠️',
    info: 'ℹ️',
  };

  const colorMap: Record<string, string> = {
    success: 'border-l-green-500 bg-green-500/10',
    error: 'border-l-red-500 bg-red-500/10',
    warning: 'border-l-amber-500 bg-amber-500/10',
    info: 'border-l-cyan-500 bg-cyan-500/10',
  };
</script>

<!-- Fixed container in top-right corner, above everything (z-50) -->
<div class="fixed top-4 right-4 z-50 flex flex-col gap-3 w-80">
  {#each toastState.toasts as toast (toast.id)}
    <div
      class="border-l-4 rounded-lg px-4 py-3 shadow-lg backdrop-blur-sm
             text-surface-100 flex items-start gap-3 animate-slide-in
             {colorMap[toast.type]}"
    >
      <span class="text-lg mt-0.5">{iconMap[toast.type]}</span>
      <p class="text-sm flex-1">{toast.message}</p>
      <button
        onclick={() => toastState.remove(toast.id)}
        class="text-surface-500 hover:text-surface-200 transition-colors cursor-pointer"
      >✕</button>
    </div>
  {/each}
</div>

<style>
  /* Slide-in animation for new toasts */
  @keyframes slide-in {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
  .animate-slide-in {
    animation: slide-in 0.3s ease-out;
  }
</style>
